import { Pipe, PipeTransform } from '@angular/core';
import { Referals } from '../models/referals';

@Pipe({ name: 'filterReferrals' })
export class FilterReferralsPipe implements PipeTransform {
  transform(referralList: Referals[], goalId: number): Referals[] {
    if (referralList && referralList.length) {
      return referralList.filter((referral) => referral.goalid === goalId);
    }

    return [];
  }
}
